import { FormControl, FormHelperText, FormLabel, Input, Tag, TagCloseButton, TagLabel, Wrap, WrapItem } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { Field } from 'formik';
import c from '../../constant';

const TagInputField = ({ name = null, label = null, required = false }) => {
	const { t } = useTranslation();

	return (
		<>
			<Field name={name}>
				{({ field, meta, form }) => (
					<FormControl id={name}>
						{label && (
							<FormLabel>
								{t(label)}
								{required && <span style={{ color: 'red' }}>*</span>}
							</FormLabel>
						)}
						<Wrap borderWidth={1} borderColor="gray.100" borderRadius={c.borderRadius} spacing={2} pl={2} pr={2} pt={1} pb={1}>
							{field?.value?.map((tag, i) => (
								<WrapItem key={i} alignItems="center">
									<Tag 
										_hover={{ backgroundColor: 'gray.200' }} 
										borderRadius={c.borderRadius}
										whiteSpace="normal" // allow multi-line
										wordBreak="break-word" // break long words
										overflowWrap="anywhere" // modern breaking
									>
										<TagLabel 
											fontSize="md" 
											pl={2} 
											pr={2} 
											pt={2} 
											pb={2}
											whiteSpace="normal"   // override TagLabel too
											wordBreak="break-word"
											overflowWrap="anywhere"
										>
											{'#' + tag}
										</TagLabel>
										<TagCloseButton
											onMouseDown={() => form?.setFieldValue(name, [...field?.value?.slice(0, i), ...field?.value?.slice(i + 1)])}
											_focus={{ boxShadow: 'none' }}
										/>
									</Tag>
								</WrapItem>
							))}
							<WrapItem flexGrow={1} alignItems="center">
								<Input
									size="md"
									flexGrow={1}
									placeholder={t('Type to input tag')}
									borderWidth={0}
									paddingInline={0}
									onKeyDown={(event) => {
										const { currentTarget, key } = event;
										if (['Enter', ' ', ',']?.includes(key)) {
											const value = currentTarget?.value;
											if (value && false === field?.value?.includes(value)) {
												const matches = value?.match(/^#+/);
												const localValue = matches?.length > 0 ? value?.slice(matches[0]?.length) : value?.slice(0);
												form?.setFieldValue(name, [...field?.value, localValue]);
											}
											currentTarget.value = '';
											event?.preventDefault();
										}
									}}
									_focus={{ boxShadow: 'none' }}
								/>
							</WrapItem>
						</Wrap>
						{meta.touched && meta.error && (
							<FormHelperText id={`error-message-${name}`} color="red.400" fontSize="12px">
								{t(name)} {t('is')} {t(meta.error)}
							</FormHelperText>
						)}
					</FormControl>
				)}
			</Field>
		</>
	);
};

export default TagInputField;
